enum ValidationEnum {
  CYRILLIC = 'cyrillic',
  NUMBER_AND_POINT = 'numberAndPoint',
  SERVICE_CODE = 'serviceCode',
}

export default ValidationEnum;
